import { Injectable, NgZone } from '@angular/core';
import { FileNode, FileInfo } from '../models/filenode';
import { Http, Response, RequestOptions, RequestMethod, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import "rxjs/add/operator/expand";
import "rxjs/Rx";
import { FilesService } from './GI.Web.Services.g';
import { HttpClient } from '@angular/common/http';
declare var AzureStorage: any;
@Injectable()
export class FileService {

  constructor(
    private _zone: NgZone,
    private _filesService: FilesService,
    private _httpClient:HttpClient
  ) {

    //  'https://gidownloadportal.blob.core.windows.net/installers?st=2017-09-11T16%3A51%3A00Z&se=2020-09-25T16%3A51%3A00Z&sp=rl&sv=2016-05-31&sr=c&sig=FvaXGgVS4WlQnYmGyeFLv58XGNcPTUHEaCbNkJKMGyA%3D'
    // this._blobService = AzureStorage.createBlobServiceWithSas(blobUri, FileService._sasToken);

  }
  // private _blobService: any;
  // //private static _sasToken = 'st=2017-09-11T16%3A51%3A00Z&se=2020-09-25T16%3A51%3A00Z&sp=rl&sv=2016-05-31&sr=c&sig=FvaXGgVS4WlQnYmGyeFLv58XGNcPTUHEaCbNkJKMGyA%3D';
  // public getFiles(): Observable<FileNode[]> {

  //   return this.GetDirectories(null);


  // }

  private getBlobService(writeAccess :boolean = false): Observable<any> {
    // TODO: This code had 2 code paths depending on write access, but that seems to be handled on the server side now. There's only one endpoint
    const blobUri = 'https://' + 'gidownloadportal' + '.blob.core.windows.net';
    // if (writeAccess) {
    return this._filesService.getContainerSAS()
      .map(t => AzureStorage.createBlobServiceWithSas(blobUri, t));
    // }
    //   else {
    //     return this._fileAccess.getContainerWriteAccessToken()
    //     .map(t => AzureStorage.createBlobServiceWithSas(blobUri, t));
    //   }

  }

  private getTableService(): Observable<any> {
    // TODO: This code had 2 code paths depending on write access, but that seems to be handled on the server side now. There's only one endpoint
    const blobUri = 'https://' + 'gidownloadportal' + '.table.core.windows.net';
    // if (writeAccess) {
      return this._filesService.getTableSAS()
        .map(t => AzureStorage.createTableServiceWithSas(blobUri, t));
    // } else {
    //   return this._fileAccess.getTableWriteAccessToken()
    //   .map(t => AzureStorage.createTableServiceWithSas(blobUri, t));
    // }

  }

  // public setRelease(file:string, release:boolean) : Observable<boolean>{
  //   return this.getBlobService(true)
  //   .switchMap(blobService => {
  //     return Observable.create((observer) => {
  //       let this_ = this;
  //           let metadata: any = {
  //             'Release' : release ? 'True' : 'False'
  //           };
            
  //           blobService.setBlobMetadata('installers', file, metadata, function (error, result) {
  //             observer.next(true);
  //             observer.complete();
  //           });
  //     });
  //   });
    
  // }

  public setProperties(file:FileInfo) : Observable<boolean>{
    return this.getBlobService(true)
    .switchMap(blobService => {
      return Observable.create((observer) => {
        let this_ = this;
            let metadata: any = {
              'archive' : file.archive ? 'true' : 'false',
              'release' : file.release ? 'true' : 'false',
              'beta' : file.beta ? 'true' : 'false',
            };
            blobService.setBlobMetadata('installers', file.name, metadata, function (error, result) {
              observer.next(true);
              observer.complete();
            });
      });
    });
    
  }


  public getFilesTree(includeArchive: boolean, includeBeta:boolean, includeNonReleased:boolean,): Observable<FileNode[]> {
    let r = this.getFilesFull(includeArchive, includeBeta, includeNonReleased, null)
      .expand(o => {
        let [token, files] = o;
        if (token != null) {
          return this.getFilesFull(includeArchive, includeBeta, includeNonReleased, token);
        } else {
          return Observable.empty();
        }
      });
    return r.map(f => { let [token, files] = f; return files; })
      .reduce((acc, x) => acc.concat(x), [])
      .map(f => FileService.parseTree(f))
    // .reduce((acc, x) => acc.concat(x), [])
    //.flatMap(f=>{
    //   return f});
    //
    // return r.map(f => FileService.parseTree(f));
  }

  // public getAllFiles(includePreRelease:boolean, token:any){
  //   return Observable.create((observer) => {
  //     let allFiles : FileInfo[] = [];
  //     this.getFilesFull(includePreRelease, null).subscribe(o=>{
  //         let [token, files] = o;
  //         files.forEach(f=>allFiles.push(f));
  //         if (token != null){
  //           this.getAllFiles(includePreRelease, token)
  //         }else{
  //         observer.next(allFiles);
  //         }
  //     });
  //   });
  // }

  public getFilesFull(includeArchive: boolean, includeBeta: boolean, includeNonReleased:boolean, token: any): Observable<[any, FileInfo[]]> {

    return this.getBlobService()
      .switchMap(blobService => {
        return Observable.create((observer) => {
          let this_ = this;
          let options: any = {};
          options.include = 'metadata';
          //options.maxResults = 10;
          blobService.listBlobsSegmented('installers', token, options, function (error, files) {
            if (error) {
              console.error(error);
            } else {
              let fileResults: FileInfo[] = [];
            //  console.info(files.continuationToken);
              for (let i = 0, blob; blob = files.entries[i]; i++) {
                let file = new FileInfo();
                file.name = blob.name;
                file.contentLength = blob.contentLength;
                file.date = blob.lastModified;
               
                if (blob.metadata.release && blob.metadata.release.toLowerCase() == "true") {
                  file.release = true;
                }

                if (blob.metadata.beta && blob.metadata.beta.toLowerCase() == "true") {
                  file.beta = true;
                }

                if (blob.metadata.archive && blob.metadata.archive.toLowerCase() == "true") {
                  file.archive = true;
                }
                //sorry they made is so complicated.....
                if (file.release || includeNonReleased) {
                    if (!file.beta && !file.archive) {
                      fileResults.push(file);
                    }
                    if (file.beta && includeBeta) {
                      fileResults.push(file);
                    } else if (file.archive && includeArchive) {
                      fileResults.push(file);
                    }
                }
              }
              this_._zone.run(() => {
                observer.next([files.continuationToken, fileResults]);
                observer.complete();
              });

            }
          }
          );
        });
      });
  }


  public getDownloadList(): Observable<any> {
    return this.getTableService()
      .switchMap(t => {
        return Observable.create((observer) => {
          var query = new AzureStorage.TableQuery();
           // .top(5000);
          t.queryEntities('downloads', query, null, function (error, result, response) {
            if (!error) {
              observer.next(result.entries);
              observer.complete();
            }
          });
        });
      });
  }

  public getUrl(blobName: string): Observable<string> {
    blobName = blobName.replace(/\//g, '"', );
    let request = this._httpClient.get('api/Files/GetUrl/' + encodeURIComponent(blobName),{responseType:'text'});
    return request;

    //doesn't work in production
    // let encodedblobName = encodeURIComponent(blobName.replace(/\//g, '"', ));
    // return this._filesService.getUrl(encodedblobName);
  }

  private static parseTree(files: FileInfo[]): FileNode[] {
    let map = new Map<string, FileNode>()

    files.forEach(file => {
      let fileNode: FileNode = map.get(file.name);
      if (fileNode == null) {
        fileNode = new FileNode();
        fileNode.data = file;
        fileNode.leaf = true;
        map.set(file.name, fileNode);
      }
      let parentName = FileService.getParentName(fileNode.data.name);
      let childNode = fileNode;
      let count = 0;
      while (parentName != '' && count++ < 100) {
        let parentNode: FileNode = map.get(parentName);
        if (parentNode == null) {
          parentNode = new FileNode();
          parentNode.children = [];
          let directoryInfo = new FileInfo();
          directoryInfo.name = parentName;
          parentNode.data = directoryInfo;
          map.set(parentName, parentNode);
        }
        childNode.parent = parentNode;
        if (parentNode.children.find(n => n.data.name == childNode.data.name) == null) {
          parentNode.children.push(childNode);
        }
        parentName = FileService.getParentName(parentNode.data.name);
        childNode = parentNode;

      }
    });
    let results = Array.from(map.values());
    results.forEach(f => {
      f.children = f.children.sort((a, b) => a.data.order > b.data.order ? -1 : 1);

    });
    return results.filter(f => f.parent == null);
  }

  private static getParentName(fileName: string) {
    let processingName = fileName;
    if (processingName.endsWith('/')) {
      processingName = processingName.substring(0, processingName.length - 1);
    }
    let parts = processingName.split('/');
    return processingName.replace(parts[parts.length - 1], '');
  }

}



// WEBPACK FOOTER //
// ./src/app/services/file.service.ts